<base-index-page 
    [config]="baseIndexPageConfig"
     [service]="proposalsService"
    [idKey]="'proposalId'"
></base-index-page>